import { messages as csCZ } from "./locales/cs-CZ";
import { messages as deAT } from "./locales/de-AT";
import { messages as deCH } from "./locales/de-CH";
import { messages as deDE } from "./locales/de-DE";
import { messages as deIT } from "./locales/de-IT";
import { messages as deLU } from "./locales/de-LU";
import { messages as frCH } from "./locales/fr-CH";
import { messages as frLU } from "./locales/fr-LU";
import { messages as itCH } from "./locales/it-CH";
import { messages as itIT } from "./locales/it-IT";
import { messages as lbLU } from "./locales/lb-LU";
import { messages as plPL } from "./locales/pl-PL";
import type { Messages } from "./types";

/** Defensive default catalog for non-screen callers and isolated tests. */
export const DEFAULT_LOCALE = "de-DE";

export const messagesByLocale = {
  "cs-CZ": csCZ,
  "de-AT": deAT,
  "de-CH": deCH,
  "de-DE": deDE,
  "de-IT": deIT,
  "de-LU": deLU,
  "fr-CH": frCH,
  "fr-LU": frLU,
  "it-CH": itCH,
  "it-IT": itIT,
  "lb-LU": lbLU,
  "pl-PL": plPL,
} satisfies Record<string, Messages>;

export type SupportedLocale = keyof typeof messagesByLocale;

/**
 * Returns product copy for a locale. Unknown locales fall back to
 * {@link DEFAULT_LOCALE} so UI never renders without a catalog.
 */
export function getMessages(locale: string | null | undefined): Messages {
  if (locale && locale in messagesByLocale) {
    return messagesByLocale[locale as SupportedLocale];
  }

  return messagesByLocale[DEFAULT_LOCALE];
}
